import { Table, Button, Row, Col, Form, Pagination } from 'react-bootstrap';
import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
import { Link, } from 'react-router-dom';
import Message from './../components/Message';
import Loader from './../components/Loader';

import {
  useGetSuppliersQuery,
  useDeleteSupplierMutation,
  useCreateSupplierMutation,
} from './../slices/suppliersApiSlice';
import { toast } from 'react-toastify';
import { useState } from 'react';

const SupplierUserList = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const { data, isLoading, error, refetch } = useGetSuppliersQuery({ pageNumber });
  const [deleteSupplier, { isLoading: loadingDelete }] = useDeleteSupplierMutation();
  const [createSupplier, { isLoading: loadingCreate }] = useCreateSupplierMutation();

  const [filter, setFilter] = useState(''); // Filter text
  const [sortField, setSortField] = useState(''); // Field to sort
  const [sortOrder, setSortOrder] = useState('asc'); // Sort order: 'asc' or 'desc'

  const deleteHandler = async (id) => {
    if (window.confirm('Are you sure you want to delete this supplier?')) {
      try {
        await deleteSupplier(id).unwrap();
        toast.success('Supplier deleted successfully');
        refetch();
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  };

  const createSupplierHandler = async () => {
    if (window.confirm('Are you sure you want to create a new supplier?')) {
      try {
        const newSupplier = {
          name: 'New Supplier',
          telephone: '0000000000',
          company: 'Default Company',
          serialNumber: '0000',
          address: 'Default Address',
        };
        await createSupplier(newSupplier).unwrap();
        toast.success('New supplier created successfully');
        refetch();
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  };

  const handleSort = (field) => {
    const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortField(field);
    setSortOrder(order);
  };

  const filterAndSortSuppliers = () => {
    let filteredSuppliers = data?.suppliers || []; // Ensure data exists

    // Filter suppliers
    if (filter) {
      filteredSuppliers = filteredSuppliers.filter(
        (supplier) =>
          supplier.name.toLowerCase().includes(filter.toLowerCase()) ||
          supplier.company.toLowerCase().includes(filter.toLowerCase()) ||
          supplier.telephone.includes(filter)
      );
    }

    // Sort suppliers
    if (sortField) {
      filteredSuppliers.sort((a, b) => {
        return sortOrder === 'asc'
          ? a[sortField].localeCompare(b[sortField])
          : b[sortField].localeCompare(a[sortField]);
      });
    }

    return filteredSuppliers;
  };

   // Handle pagination changes
   const paginationHandler = (page) => {
    setPageNumber(page);
  };

  return (
    <>
      <Row className="align-items-center">
        <Col>
          <h1>Suppliers</h1>
        </Col>
        <Col className="text-end">
          <Button className="my-3" onClick={createSupplierHandler}>
            <FaPlus /> Create Supplier
          </Button>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={4}>
          <Form.Control
            type="text"
            placeholder="Filter by name, company, or telephone"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />
        </Col>
      </Row>

      {loadingCreate && <Loader />}
      {loadingDelete && <Loader />}
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error.data?.message}</Message>
      ) : (
        <>
          <Table striped bordered hover responsive className="table-sm">
            <thead>
              <tr>
                <th onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>
                  NAME {sortField === 'name' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                </th>
                <th onClick={() => handleSort('company')} style={{ cursor: 'pointer' }}>
                  COMPANY {sortField === 'company' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                </th>
                <th onClick={() => handleSort('telephone')} style={{ cursor: 'pointer' }}>
                  TELEPHONE {sortField === 'telephone' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                </th>
                <th onClick={() => handleSort('serialNumber')} style={{ cursor: 'pointer' }}>
                  SERIAL {sortField === 'serialNumber' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                </th>
                <th>ADDRESS</th>
                <th>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {filterAndSortSuppliers().map((supplier) => (
                <tr key={supplier._id}>
                  <td>{supplier.name}</td>
                  <td>{supplier.company}</td>
                  <td>{supplier.telephone}</td>
                  <td>{supplier.serialNumber}</td>
                  <td>{supplier.address}</td>
                  <td>
                    <Button
                      as={Link}
                      to={`/supplier/${supplier._id}/edit`}
                      variant="light"
                      className="btn-sm mx-2"
                    >
                      <FaEdit />
                    </Button>
                    <Button
                      style={{ display: 'none' }}
                      variant="danger"
                      className="btn-sm"
                      onClick={() => deleteHandler(supplier._id)}
                    >
                      <FaTrash style={{ color: 'white' }} />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Pagination>
                       {[...Array(data.pages).keys()].map((x) => (
                         <Pagination.Item
                           key={x + 1}
                           active={x + 1 === pageNumber}
                           onClick={() => paginationHandler(x + 1)}
                         >
                           {x + 1}
                         </Pagination.Item>
                       ))}
            </Pagination>

          
        </>
      )}
    </>
  );
};

export default SupplierUserList;